import type { ReactElement } from "react";
import { Skeleton } from "@/components/atoms";
import "./SpaceCardSkeleton.scss";

/** Loading placeholder matching SpaceCard layout. */
export function SpaceCardSkeleton(): ReactElement {
  return (
    <div className="space-card-skeleton" aria-hidden="true">
      <div className="space-card-skeleton__content">
        <div className="space-card-skeleton__logo-wrap">
          <Skeleton
            variant="circle"
            width={80}
            height={80}
            borderWeight="strong"
            className="space-card-skeleton__logo"
          />
        </div>
        <Skeleton variant="text" width="70%" height={32} borderRadius="base" />
        <Skeleton variant="text" width="85%" height={28} />
        <Skeleton
          borderRadius="base"
          className="space-card-skeleton__contact-panel"
        />
        <div className="space-card-skeleton__alignment" />
        <div className="space-card-skeleton__tenant-cta">
          <Skeleton
            variant="text"
            width="100%"
            height={40}
            borderRadius="base"
            className="space-card-skeleton__tenant-cta-button"
          />
        </div>
        <div className="space-card-skeleton__social-row">
          <Skeleton variant="circle" width={49} height={49} />
          <Skeleton variant="circle" width={49} height={49} />
          <Skeleton variant="circle" width={49} height={49} />
          <Skeleton variant="circle" width={49} height={49} />
        </div>
      </div>
    </div>
  );
}
